
/*
DC:Downsamples  color/grayscale images.
CC:Compresses color/grayscale images.
DM:Downsamples monochrome images only.
CM:Compresses monochrome images only.
 */

// be used for compress/reduce file size
const CompressParams = {
  "DC_DPIAbove":"0",
  "DC_DPISet":"0",
  "CC_BlockSize":"256",
  "DM_DPIAbove":"0",
  "DM_DPISet":"0",
  "CM_BlockSize":"256"
}
export {
  CompressParams
}